import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
export function SubscribeForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 1500);
  };
  return <div className="w-full max-w-md mx-auto mt-8" data-id="element-33">
      {status === 'success' ? <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-green-500/10 text-green-400 p-5 rounded-xl border border-green-500/20 text-center font-medium" data-id="element-34">
          धन्यवाद! हम आपको जल्द ही अपडेट करेंगे।
          <div className="text-sm text-green-500/70 mt-1" data-id="element-35">
            (Thank you! We will update you soon.)
          </div>
        </motion.div> : <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3" data-id="element-36">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="अपना ईमेल दर्ज करें..." className="flex-1 bg-zinc-900/50 border border-zinc-800 rounded-xl px-5 py-3.5 text-zinc-100 focus:outline-none focus:border-brand-red focus:ring-1 focus:ring-brand-red transition-all placeholder:text-zinc-500 shadow-inner" required disabled={status === 'submitting'} data-id="element-37" />
          <button type="submit" disabled={status === 'submitting'} className="bg-brand-red hover:bg-rose-700 text-white px-8 py-3.5 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all disabled:opacity-70 disabled:cursor-not-allowed shadow-lg shadow-brand-red/20" data-id="element-38">
            {status === 'submitting' ? <span className="animate-pulse" data-id="element-39">भेज रहे हैं...</span> : <>
                <span data-id="element-40">सब्सक्राइब करें</span>
                <Send className="w-4 h-4" data-id="element-41" />
              </>}
          </button>
        </form>}

      {!status || status !== 'success' && <p className="text-zinc-500 text-sm mt-4 text-center" data-id="element-42">
            हम स्पैम नहीं भेजते। केवल महत्वपूर्ण खबरें।
          </p>}
    </div>;
}